import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import moment, { Moment } from 'moment';

@Component({
    selector: 'app-year-toggle',
    templateUrl: './year-toggle.component.html',
    styleUrls: ['./year-toggle.component.scss'],
    standalone: false
})
export class YearToggleComponent implements OnInit {

  @Output() YearChange = new EventEmitter();
  public selectedDate: Moment;

  constructor() { }

  ngOnInit(): void {
    this.selectedDate = moment.utc();
  }

  public toggleYears(type: string): void {
    const currentYear = moment().get('year');
    let year = this.selectedDate.year();

    if (type === '+') {
      year = year >= (currentYear + 2) ? year : (year + 1);
    }

    if (type === '-') {
      year = year <= (currentYear - 2) ? year : (year - 1);
    }

    this.selectedDate.year(year);
    this.YearChange.emit(this.selectedDate);
  }

}
